import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { WebStorage } from './web.storage';
import { Injectable } from '@angular/core';
// import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AppConfig } from '../config/app.config';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  // private router: Router    
  constructor(
    private toaster: ToastrService,
    // private location: Location,
    private router: Router,
    private auth: AuthService,
    private config: AppConfig,
    private storage: WebStorage,
    // private tmpStorage: TmpStorage
  ) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log("here")
    return next.handle(request)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          let errorMessage = '';
          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
          } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
          }


          switch (error.status) {
            case 401:
              this.toaster.error("Unauthorized request")
              this.auth.logout();
              // this.router.navigate[''];
              break;
            case 403:
              this.toaster.error("Forbidden request")
              // this.auth.logout();
              // this.router.navigate[''];
              break;
            case 404:
              this.toaster.error("Not found")
              break;
            default:
              this.toaster.error(errorMessage)
          }

          console.log("got error---", error)
          // this.router.navigate[''];
          // this.auth.logout();
          // if(error.)

          // window.alert(errorMessage);
          return throwError(errorMessage);
        })
      )
  }
}